import { Component, OnInit } from '@angular/core';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {Editors, Filters, Formatters} from 'angular-slickgrid';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';


@Component({
  selector: 'app-view-category',
  templateUrl: './view-category.component.html',
  styleUrls: ['./view-category.component.css']
})
export class ViewCategoryComponent implements OnInit {


  userSelected: number;
  groupSelected: number;
  show: boolean;
  dataset: any[];
  totalData: number;
  respObject: any;
  users = [];
  groups = [];
  userName: string;
  groupName: string;

  slideChecked = true;
  displayData: any;

  add = false;
  del = false;
  edit = false;
  view = false;

  isError = false;
  errorMessage: string;

  private notifier: NotifierService;
  private clientId: number;
  spocChecked = false;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private userAuth: Subscription;
  private baseFlag: any;
  offset: number;
  dataLoaded: boolean;
  showExportBtn = true;
  dataExcel = [];
  isExportDisable = false;

  // private modalReference: NgbModalRef;

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
    private modalService: NgbModal, notifier: NotifierService) {
      this.notifier = notifier;
      this.messageService.getCellChangeData().subscribe(item => {
          switch (item.type) {
              case 'change':
                  // console.log('changed');
                  if (!this.messageService.edit) {
                      this.notifier.notify('error', 'You do not have edit permission');
                  } else {

                  }
                  break;
              case 'delete':
                  break;
          }
      });
     }

  ngOnInit() {

    this.dataLoaded = false;
    this.groupSelected = 0;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
        pageName: 'View Category',
        openModalButton: 'Category Filter',
        breadcrumb: 'View Category',
        folderName: 'View Category',
        tabName: 'View Category',
        exportBtn: 'Export to excel'

    };
    const columnDefinitions = [
        {
            id: 'SupportGroup', name: 'Support Group', field: 'groupname', sortable: true, filterable: true
        },
        {
            id: 'Category', name: 'Category', field: 'attrVal', sortable: true, filterable: true
        },
        {
            id: 'ticketType', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true
        }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
        this.clientId = this.messageService.clientId;
        this.baseFlag = this.messageService.baseFlag;
        this.onPageLoad();
    } else {
        this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
            this.view = auth[0].viewFlag;
            this.add = auth[0].addFlag;
            this.edit = auth[0].editFlag;
            this.del = auth[0].deleteFlag;
            this.clientId = auth[0].clientId;
            this.baseFlag = auth[0].baseFlag;
            this.onPageLoad();
        });
    }


  }


  onPageLoad() {
    this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.isError = false;
            this.respObject.details.unshift({id: 0, name: 'Select Support Group'}, {id: -1, name: 'All'});
            this.groups = this.respObject.details;
            this.groupSelected = 0;
        } else {
            this.isError = true;
            this.errorMessage = this.respObject.errorMessage;
        }
    }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
    });
    this.getTableData();
}

  filter() {
    this.page_no = 0;
    this.nextOffset = 0;
    this.getData({'offset': this.nextOffset, 'paginationType': ''})
}

exportToExcel() {
    this.isExportDisable = true;

    // console.log("okkk" +this.clientId);
    this._rest.getAllCategoryandSupportGroup(this.clientId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.isExportDisable = false;

            this.dataExcel = this.respObject.details;
            // console.log('true' + JSON.stringify(this.dataExcel));
            this.messageService.exportAsExcelFile(this.dataExcel);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
}



openModal(content) {
  if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
  } else {
      this.isError = false;
      this.groupSelected = 0;
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {
      });
  }
}
changeRouting(path: string) {
  this.messageService.changeRouting(path);
}


getTableData() {
  if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
  } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }
}


isEmpty(obj) {
  for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
          return false;
      }
  }
  return true;
}

getData(paginationObj) {
  const offset = paginationObj.offset;
  const paginationType = paginationObj.paginationType;
  this.dataLoaded = false;
  this.respObject = [];
  this.groupSelected
  this._rest.getCategoryGroupMapping(this.clientId, offset, this.pageSize, paginationType, this.groupSelected).subscribe((res) => {
      this.respObject = res;
      // console.log("aaaa"+JSON.stringify(this.respObject));
      this.executeResponse(this.respObject, offset, paginationType);
  }, (err) => {
      this.notifier.notify('error', JSON.stringify(err));
  });
}


executeResponse(respObject, offset, paginationType) {
  if (respObject.success) {
      this.dataLoaded = true;

      if (offset === 0) {
          this.totalData = respObject.details.totalData[0].count;
          this.totalPage = respObject.details.totalPage;
          if (this.totalPage === 0) {
              this.totalPage = 1;
          }
      }
      if (!this.isEmpty(respObject.details.dataObj)) {
          const data = respObject.details.dataObj;
          this.nextOffset = respObject.details.nextOffset;
          this.offset = respObject.details.nextOffset;
          this.previousOffset = respObject.details.previousOffset;
          this.messageService.setTotalData(this.totalData);
          this.messageService.setGridData(data);
          // ----------------------------------------------
          if (offset !== 0) {
              const totalCount = this.totalData;
              const divRes = totalCount / this.pageSize;
              const remainder = totalCount % this.pageSize;
              if (remainder === 0) {
                  this.totalPage = parseInt(String(divRes), 10);
              } else {
                  this.totalPage = parseInt(String(divRes), 10) + 1;
              }
          }
          // ------------------------------------------------
          if (paginationType === 'next') {
              this.page_no = this.page_no + 1;
          } else if (paginationType === 'prev') {
              this.page_no = this.page_no - 1;
          } else if (paginationType === '' && this.page_no === 0) {
              this.page_no = this.page_no + 1;
          }
          if (this.totalData <= this.pageSize * this.page_no) {
              this.nextOffset = 0;
          }
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
          this.nextOffset = 0;
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
          this.previousOffset = 0;
      } else if (paginationType === '' && this.page_no === 0) {
          this.page_no = this.page_no + 1;
      }
  } else {
      this.notifier.notify('error', respObject.errorMessage);
  }
}


onPageSizeChange(value: any) {
  this.page_no = 0;
  this.nextOffset = 0;
  this.pageSize = value;
  this.getData({'offset': this.nextOffset, 'paginationType': ''});
}

ngOnDestroy(): void {
  if (this.userAuth) {
      this.userAuth.unsubscribe();
  }
}
}
